export default "/images/services.jpg?3898320eaa893191aa8ab560a2ab94da";